import { createAsyncThunk } from '@reduxjs/toolkit';
import thunkErrorSerializer from './thunkErrorSerializer';

/**
 * A wrapper for any async thunk that makes an axios request.
 * Adding thunkErrorSerializer to the options will pass the error payload from fusion to the reducer.
 */
const createAxiosThunk = (name, payloadCreator, options = {}) =>
  createAsyncThunk(name, payloadCreator, { serializeError: thunkErrorSerializer, ...options });

export default createAxiosThunk;
